import React from "react";
import { Container, Row, Col, Card, CardBody, Alert } from "reactstrap";
import CrearPlantillaMensaje from "./Crear";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { DatosSesion } from "../../../Components/Common/DatosSesion";

const Crear = () => {
  document.title = "Crear Plantilla de Mensaje | Farme";
  const perfil = DatosSesion("perfil");
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {perfil === "Administrador" ||
          perfil === "Farmacia" ||
          perfil === "MyHealth" ? (
            <>
              <BreadCrumb
                title="Crear Plantilla de Mensaje"
                pageTitle="Listar Plantillas de Mensajes"
                url="/plantillas-mensajes"
              />
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <CrearPlantillaMensaje />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Alert color="danger">
              No tienes permisos para ver esta página.
            </Alert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Crear;
